import {
  CreateCompanyRequest,
  CreateCompanyResponse,
} from '@/modules/leadIndication/entities/leadIndication.interface';
import EligibilityService from '@/modules/leadIndication/services/eligibilityService';
import { useRequestCreation } from '@/shared/hooks/useRequestData/useRequestCreation';

const eligibilityService = new EligibilityService();

export interface UseCreateCompanyOptions {
  onSuccess?: (response: CreateCompanyResponse, entity: CreateCompanyRequest) => void;
}

/**
 * Cria a empresa indicadora a partir dos dados preenchidos no fluxo.
 *
 * Chama o serviço `createCompany`, reaproveitando `useRequestCreation`,
 * com tipagem explícita para request/response. Expõe função de criação,
 * `loading` e callback de sucesso para associar a empresa criada à indicação.
 */
const useCreateCompany = ({ onSuccess }: UseCreateCompanyOptions = {}) => {
  const { requestCreate, loading } = useRequestCreation<
    CreateCompanyRequest,
    CreateCompanyResponse
  >({
    request: (params) => eligibilityService.createReferringCompany(params),
    callback: onSuccess,
  });

  return {
    createCompany: requestCreate,
    loading,
  };
};

export default useCreateCompany;
